module.exports = __webpack_public_path__ + "static/media/mobile-marketing.720a92f3.jpg";